import React, { useState } from 'react';
import '../../styles/FAQ.css';
import { getFaqs } from '../../api/contentApi';

const CATEGORIES = ['All', 'Courses & Access', 'Payments & Refunds', 'Mentorship & Community'];

const FALLBACK_FAQ_DATA = [
  {
    id: 1,
    category: 'Courses & Access',
    question: 'How long do I get access to the courses and assets?',
    answer: 'You receive lifetime access to all purchased courses, including all future module additions, video updates, sound packs, and LUT library expansions with no recurring subscription.'
  },
  {
    id: 2,
    category: 'Courses & Access',
    question: 'Can I watch lessons on my mobile or tablet?',
    answer: 'Yes! The entire dashboard is fully responsive. You can stream lessons across desktop, iPad, Android tablets, and mobile devices anytime.'
  },
  {
    id: 3,
    category: 'Payments & Refunds',
    question: 'What payment options do you accept?',
    answer: 'We accept all major Indian and international payment methods including UPI (Google Pay, PhonePe, Paytm), Debit/Credit Cards (Visa, MasterCard, RuPay), and Net Banking via secure gateways.'
  },
  {
    id: 4,
    category: 'Payments & Refunds',
    question: 'What is your refund policy?',
    answer: 'We provide a 30-day money-back guarantee. If you complete the initial lessons and find the course doesn’t suit your workflow, submit a refund request to hello@creatorsdost.com within 30 days.'
  },
  {
    id: 5,
    category: 'Mentorship & Community',
    question: 'How do live sessions with Graduate FF work?',
    answer: 'Live interactive masterclasses are scheduled regularly in your student dashboard. You can join the private stream, ask questions live in chat, and get your video edits/hooks audited on screen.'
  },
  {
    id: 6,
    category: 'Mentorship & Community',
    question: 'How do I access the private student community?',
    answer: 'Once enrolled, a private invitation link will appear inside your student portal under the "Community" tab to join our private creator network.'
  },
  {
    id: 7,
    category: 'Courses & Access',
    question: 'Do I get a certificate upon completion?',
    answer: 'Yes, once you finish 100% of the lessons and submit the project milestone, a verified, shareable digital certificate will be generated on your profile.'
  }
];

export default function FAQ() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [openIndex, setOpenIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [faqData, setFaqData] = useState(null);

  React.useEffect(() => {
    getFaqs({
      search: searchTerm,
      category: activeCategory,
    })
      .then((items) => setFaqData(Array.isArray(items) ? items.map((item, index) => ({
        id: `${item.courseId || 'general'}-${index}`,
        category: item.category || 'Courses & Access',
        question: item.question,
        answer: item.answer || '',
      })) : []))
      .catch((error) => console.error('Unable to load FAQs:', error));
  }, [activeCategory, searchTerm]);

  const toggleAccordion = (id) => {
    setOpenIndex((prev) => (prev === id ? null : id));
  };

  const filteredFaqs = faqData
    ? faqData
    : FALLBACK_FAQ_DATA.filter((item) => {
        const matchesCategory = activeCategory === 'All' || item.category === activeCategory;
        const matchesSearch = item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
                              item.answer.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
      });

  return (
    <div className="faq-page-wrapper">
      <div className="faq-container">
        
        {/* HEADER */}
        <header className="faq-header">
          <span className="faq-pill-badge">HELP & SUPPORT</span>
          <h1 className="faq-main-title">
            Frequently Asked <span>Questions</span>
          </h1>
          <p className="faq-subtitle">
            Find quick answers about curriculum access, mentorship, certifications, and payments.
          </p>

          {/* SEARCH BAR */}
          <div className="faq-search-box">
            <span className="faq-search-icon">🔍</span>
            <input 
              type="text" 
              placeholder="Search your question here..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="faq-search-input"
            />
          </div>
        </header>

        {/* CATEGORY FILTER PILLS */}
        <div className="faq-filter-row">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              type="button"
              className={`faq-cat-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* ACCORDION LIST */}
        <div className="faq-accordion-list">
          {filteredFaqs.length > 0 ? (
            filteredFaqs.map((faq) => {
              const isOpen = openIndex === faq.id;
              return (
                <div className={`faq-card ${isOpen ? 'is-open' : ''}`} key={faq.id}>
                  <button 
                    type="button" 
                    className="faq-question-btn"
                    onClick={() => toggleAccordion(faq.id)}
                  >
                    <span className="faq-question-text">{faq.question}</span>
                    <span className="faq-icon-indicator">{isOpen ? '−' : '+'}</span>
                  </button>
                  <div className="faq-answer-collapse">
                    <p className="faq-answer-text">{faq.answer}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="faq-empty-state">
              <p>No questions matched your search.</p>
            </div>
          )}
        </div>

        {/* BOTTOM SUPPORT CALLOUT */}
        <div className="faq-contact-card">
          <div className="faq-contact-info">
            <h3>Still have questions?</h3>
            <p>Can’t find what you’re looking for? Reach out directly to our team.</p>
          </div>
          <a href="mailto:hello@creatorsdost.com" className="faq-contact-btn">
            Contact Support ✉️
          </a>
        </div>

      </div>
    </div>
  );
}